import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import DigitalAssetSelectors from '../../../../modules/domain/digitalAsset/selectors'
import { useAction } from '@agro-club/frontend-shared'
import DigitalAssetActions from '../../../../modules/domain/digitalAsset/duck'
import { DigitalAssetListRequestFilter } from '../../../../modules/domain/digitalAsset/types'
import { DatePicker, Flex, Typography } from 'antd'

const { RangePicker } = DatePicker
const { Text } = Typography

/* Select component for filtering digital assets using the date when the digital asset was created
 *
 * */
const DACreationDateFilterDatePicker: React.FC = () => {
  const { t } = useTranslation('digitalAsset')
  const filter = useSelector(DigitalAssetSelectors.filter)
  const filterUpdated = useAction(DigitalAssetActions.filterUpdated)
  let { start_date, end_date } = filter

  const onDateChange = (date, _dateString) => {
    const [start, end] = date ?? [null, null]
    start_date = start?.toISOString()
    end_date = end?.toISOString()
    handleFilterChange({ start_date, end_date })
  }

  const handleFilterChange = useCallback(
    (newFilterValue: Partial<DigitalAssetListRequestFilter>) => {
      filterUpdated({ ...filter, ...newFilterValue })
    },
    [filterUpdated, filter],
  )

  return (
    <Flex vertical flex={1}>
      <Text>{t('select.uploadedDate')}</Text>
      <RangePicker
        size="large"
        allowEmpty
        format={'YYYY-MM-DD HH:mm:ss'}
        needConfirm
        onChange={onDateChange}
      ></RangePicker>
    </Flex>
  )
}

export default DACreationDateFilterDatePicker
